import Styled from 'styled-components'

export const Container = Styled.div`
margin-top: 20px;
margin: 0 2%;

margin-bottom: 30px;

@media(max-width: 800px) {
  margin: 0 5%;
}

`

export const H1 = Styled.h1`
text-align: center;
color: #0b3275;
font-size: 25px;
margin-top: 40px;
margin-bottom: 40px;
`

export const Break = Styled.br`
`

export const Logo = Styled.img`
margin-top: 40px;
max-width: 40px;
`